import ProfessionalAttachment from "../../models/ProfessionalAttachment";
import ProfessionalAttachmentService from "../../services/ProfessionalAttachmentService";
import FormBase from "../FormBase";
import FormFieldAttachmentBase, { FieldAttachment } from "../FormFieldAttachmentBase";
import ValidationBase, { ValidationType } from "../ValidationBase";

export enum EAttachmentReRegistration {
    CartaAutorizacaoAssinada = 27,
    CarteiraProfissionalClasse = 28,
    CertificadoAtuacaoInstrumentacao = 29,
    CPFeRG = 30,
    TituloEspecialista = 31,
    RelatorioMedico = 60,
}

export class ReRegistrationAttachmentFormItem {
    Id: number;
    AttachmentTypeId: number;
    AttachmentTypeTasyId: number;
    DescriptionTasy: string;
    Description: string;
    LinkFileName: string  | undefined;
    HelperIcon: "info" | "error" | "warning" | undefined;
    HelperText: string | undefined;
    LinkFile: string  | undefined;
    FileName: string | undefined;
    EncriptId: string | undefined;
    DeliveryDate: string | undefined;
    Expired: boolean | undefined;
    FileField: FormFieldAttachmentBase | undefined;
    Error: string;
    HasError: boolean;

    constructor(Id: number, DescriptionTasy: string, DeliveryDate: string) {
        this.Id = Id;
        this.AttachmentTypeId = 0;
        this.AttachmentTypeTasyId = 0;
        this.DescriptionTasy = DescriptionTasy;
        this.Description = "";
        this.FileName = "";
        this.LinkFileName = undefined;
        this.LinkFile = undefined;
        this.EncriptId = "";
        this.DeliveryDate = DeliveryDate;
        this.Error = "";
        this.HasError = false;
    }

    static NewInstance(): ReRegistrationAttachmentFormItem {
        return new ReRegistrationAttachmentFormItem(0, "", "");
    }

}


export default class ReRegistrationAttachmentForm implements FormBase {

    FilesInsertedInTasy: ReRegistrationAttachmentFormItem[];
    FilesPendingInclusion: ReRegistrationAttachmentFormItem[];
    ExistOptionalFiles: boolean;
    ExistMandatoryFiles: boolean;

    constructor() {
        this.FilesInsertedInTasy = new Array<ReRegistrationAttachmentFormItem>();
        this.FilesPendingInclusion = new Array<ReRegistrationAttachmentFormItem>();
        this.ExistOptionalFiles = false;
        this.ExistMandatoryFiles = false;
    }

    static NewInstance(): ReRegistrationAttachmentForm {
        return new ReRegistrationAttachmentForm();
    }

    CallInsertOrUpdateApi(): Promise<boolean> {
        return Promise.resolve(true);
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {

        let promises: any[] = [];


        promises.push(await ProfessionalAttachmentService.CreateAndGetProfessionalAttachmentFromTasy(requestId).then((data: ProfessionalAttachment[]) => {

            this.FilesInsertedInTasy = new Array<ReRegistrationAttachmentFormItem>();

            for (let index = 0; index < data.length; index++) {
                const element = data[index];

                if (element.TasyCode != null && element.TasyCode > 0) {
                    let item = ReRegistrationAttachmentFormItem.NewInstance();
                    item.DeliveryDate = element.DeliveryDate;
                    item.DescriptionTasy = element.DescriptionTasy;
                    item.Description = element.Description;
                    item.Expired = element.Expired;
                    this.FilesInsertedInTasy.push(item);
                }
            }
        })
        );

        promises.push(await ProfessionalAttachmentService.GetProfessionalAttachmentPending(requestId).then((data: ProfessionalAttachment[]) => {

            this.FilesPendingInclusion = new Array<ReRegistrationAttachmentFormItem>();
            
            var urlFile: string = "";

            // Usar um objeto para rastrear os valores únicos
            var attachmentUnicTypes = [];

            // Percorrer a lista para remover os Tipos Duplicados
            for (let index = 0; index < data.length; index++) {
                const element = data[index].AttachmentTypeId;

                // Verificar se o valor já existe no objeto de valores únicos
                var exist = false;

                for (let indexType = 0; indexType < attachmentUnicTypes.length; indexType++) {
                    if (attachmentUnicTypes[indexType] === element) {
                        exist = true;
                    }
                }

                if (!exist) {
                    attachmentUnicTypes.push(element);
                }
            }

            //Percorre de tipos de arquivos únicos
            for (let index = 0; index < attachmentUnicTypes.length; index++) {

                var filedAttachemntInserted = [];
                var attachmentInserted: ProfessionalAttachment | undefined = undefined;

                //Percorre a lista de anexos para verificar se já tem arquivos com anexos na base
                for (let indexAttachemts = 0; indexAttachemts < data.length; indexAttachemts++) {

                    //Verifica se já existe aquele tipo de arquivo na lista salva na base e que contenha arquivo
                    if (data[indexAttachemts].AttachmentTypeId === attachmentUnicTypes[index] && data[indexAttachemts].FileName !== "" && data[indexAttachemts].FileName !== null) {

                        const fileInserted = data[indexAttachemts];

                        if (fileInserted.EncriptId !== undefined) {
                            var fieldAttachment = new FieldAttachment(undefined, fileInserted.EncriptId);
                            fieldAttachment.File = {
                                path: fileInserted.FileName,
                                lastModified: new Date().getTime(),
                                lastModifiedDate: new Date(),
                                name: fileInserted.FileName,
                                type: "image/png",
                                webkitRelativePath: ""
                            }

                            filedAttachemntInserted.push(fieldAttachment);
                            attachmentInserted = fileInserted;
                        }
                    }
                }

                //Se tiver arquivos inseridos na base
                if (filedAttachemntInserted.length > 0 && attachmentInserted !== undefined) {

                    let item = ReRegistrationAttachmentFormItem.NewInstance();
                    item.DescriptionTasy = attachmentInserted.DescriptionTasy;
                    item.Description = attachmentInserted.Description;
                    item.AttachmentTypeId = attachmentInserted.AttachmentTypeId;
                    if (attachmentInserted.Mandatory) {
                        item.FileField = new FormFieldAttachmentBase([], 3, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], null);
                        this.ExistMandatoryFiles = true;
                    } else {
                        item.FileField = new FormFieldAttachmentBase([], 3, [], null);
                        this.ExistOptionalFiles = true;
                    }


                    switch(item.AttachmentTypeTasyId){
                        case 97:// Atestado de Capacidade Física e Cognitiva atualizado
                            item.LinkFileName = "(visualizar modelo)";
                            urlFile = `/assets/ATESTADO_CAPACIDADE_FISICA_COGNITIVA_2026.pdf`
                            item.LinkFile = urlFile;
                            item.HelperIcon = "warning";
                            item.HelperText = "O atestado de aptidão física e mental deve ser emitido e assinado por outro profissional médico."
                        break;
                        case 105:// Comprovante de covid
                            item.LinkFileName = "(visualizar modelo)";
                            urlFile = `/assets/DECLARACAO_IMUNIDADE_PREVIA_VIRUS_HEPATITE_B.doc`
                            item.LinkFile = urlFile;
                        break;
                        case 92:// Carteira de Vacinação
                            item.LinkFileName = "(visualizar modelo)";
                            urlFile = `/assets/TERMO_RECUSA_APRESENTAR_COMPROVACAO_VACINAL_V2.pdf`
                            item.LinkFile = urlFile;
                        break;
                        case 76:// Declaração de Conflito de Interesse atualizada
                            item.LinkFileName = "(visualizar modelo)";
                            urlFile = `/assets/DECLARACAO_SEM_CONFLITO_V2.pdf`
                            item.LinkFile = urlFile;
                        break;
                    }

                    new FormFieldAttachmentBase([], 3, [], null);

                    for (let index = 0; index < filedAttachemntInserted.length; index++) {
                        item.FileField.Values.push(filedAttachemntInserted[index]);
                    }

                    this.FilesPendingInclusion.push(item);

                    // Caso não tem arquivos inseridos para aquele tipo, cria uma pendência
                } else {

                    //Percorre a lista de anexos para verificar se já tem arquivos com anexos na base
                    for (let indexAttachemts = 0; indexAttachemts < data.length; indexAttachemts++) {

                        //Verifica se já existe aquele tipo de arquivo na lista salva na base e que contenha arquivo
                        if (data[indexAttachemts].AttachmentTypeId === attachmentUnicTypes[index]) {

                            const fileInserted = data[indexAttachemts];

                            let item = ReRegistrationAttachmentFormItem.NewInstance();
                            item.DescriptionTasy = fileInserted.DescriptionTasy;
                            item.Description = fileInserted.Description;
                            item.AttachmentTypeId = fileInserted.AttachmentTypeId;
                            item.AttachmentTypeTasyId = fileInserted.AttachmentTypeTasyId;
                            if (fileInserted.Mandatory) {
                                item.FileField = new FormFieldAttachmentBase([], 3, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], null);
                                this.ExistMandatoryFiles = true;
                            } else {
                                item.FileField = new FormFieldAttachmentBase([], 3, [], null);
                                this.ExistOptionalFiles = true;
                            }

                            switch(item.AttachmentTypeTasyId){
                                case 97:// Atestado de Capacidade Física e Cognitiva atualizado
                                    item.LinkFileName = "(visualizar modelo)";
                                    urlFile = `/assets/ATESTADO_CAPACIDADE_FISICA_COGNITIVA_2026.pdf`
                                    item.LinkFile = urlFile;
                                    item.HelperIcon = "warning";
                                    item.HelperText = "O atestado de aptidão física e mental deve ser emitido e assinado por outro profissional médico."
                                break;
                                case 105:// Comprovante de covid
                                    item.LinkFileName = "(visualizar modelo)";
                                    urlFile = `/assets/DECLARACAO_IMUNIDADE_PREVIA_VIRUS_HEPATITE_B.doc`
                                    item.LinkFile = urlFile;
                                break;
                                case 92:// Carteira de Vacinação
                                    item.LinkFileName = "(visualizar modelo)";
                                    urlFile = `/assets/TERMO_RECUSA_APRESENTAR_COMPROVACAO_VACINAL_V2.pdf`
                                    item.LinkFile = urlFile;
                                break;
                                case 76:// Declaração de Conflito de Interesse atualizada
                                    item.LinkFileName = "(visualizar modelo)";
                                    urlFile = `/assets/DECLARACAO_SEM_CONFLITO_V2.pdf`
                                    item.LinkFile = urlFile;
                                break;
                            }

                            this.FilesPendingInclusion.push(item);
                            break;
                        }

                    }
                }

            }


        })
        );

        return Promise.all(promises);
    }

    ValidateToGoNextStep(state?: any): string {

        let formIsValid = true;
        let maxLengthIsValid = true;

        for (let index = 0; index < this.FilesPendingInclusion.length; index++) {
            const element = this.FilesPendingInclusion[index];

            if (element.FileField !== undefined) {
                const error = element.FileField.ValidateField(state);

                if (error !== null && error !== "") {
                    formIsValid = false;
                }

                if (element !== null) {

                    let files = element.FileField.Values;

                    for (let indexFile = 0; indexFile < files.length; indexFile++) {
                        const file = files[indexFile];

                        if (file.ErrorMessage !== null && file.ErrorMessage !== "") {
                            formIsValid = false;
                            maxLengthIsValid = false;
                        }
                    }
                }
            }
        }

        if (!formIsValid) {
            if (!maxLengthIsValid) {
                return "O tamanho do arquivo é maior do que o permitido, impossibilitando avançar. Favor remover e inserir arquivo do tamanho de até 3MB."
            } else {
                return "Por favor, insira os anexos obrigatórios."
            }
        } else {
            return "";
        }
    }


    GetFieldByName(name: string): FormFieldAttachmentBase {
        return new FormFieldAttachmentBase([], 0, []);
    }
};
